<template>
	<div id="body">
		<div class="title">
			<i class="el-icon-warning-outline"></i> 操作成功
		</div>

		<el-row>
			<el-col :sm="12" :lg="6">
				<el-result icon="success" title="成功提示">
					<template slot="extra">
						{{ text }}
					</template>
				</el-result>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: "",
		data() {
			return {
				text: '成功',
			};
		},
		methods: {

		},
		created() {
			this.text = this.$route.query.text
		}
	};
</script>

<style scoped="scoped">

</style>
